import { render } from "./aboutManage.vue?vue&type=template&id=b42b4794&scoped=true"
import script from "./aboutManage.vue?vue&type=script&lang=js"
export * from "./aboutManage.vue?vue&type=script&lang=js"

import "./aboutManage.vue?vue&type=style&index=0&id=b42b4794&lang=less&scoped=true"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42b4794"]])

export default __exports__